import { FacilityDefaults } from '~/hooks/useFacilityDefaults'
import { createContext, useContext } from 'react'
import { Edge } from '../util/comfortZone'

export const PerformanceMetricsContext = createContext<PerformanceMetricsProps | null>(null)

export type PerformanceMetricsProps = {
  facility: Omit<FacilityDefaults, 'primaryObjective'>
  areaOfConcernEdges: Edge[] | null
  selectedVtkFiles: object
  occupantAirflow: boolean
}

export function usePerformanceMetricsProps() {
  const props = useContext(PerformanceMetricsContext)
  if (props === null) throw new Error('usePerformanceMetricsProps must be used within context')
  return props
}
